export const OPENED_DRAWER_WIDTH_PX = 220;
export const CLOSED_DRAWER_WIDTH_PX = 72;
